/**
 * Module 1 : Structure de Base - Types TypeScript
 * 
 * Définitions des types selon le cahier des charges
 * Architecture modulaire stricte - Isolation totale
 */

import * as THREE from 'three';

// Types de formes supportées (Tâche 1.1)
export enum TypeForme {
  CERCLE = 'cercle',
  OVALE = 'ovale',
  CARRE = 'carre',
  RECTANGLE = 'rectangle',
  POLYGONE = 'polygone'
}

// Types de matériaux pour toute la tonnelle
export enum TypeMateriauGlobal {
  FER_A_BETON = 'fer_a_beton',    // Section ronde pour toute la structure
  TUBE_CARRE = 'tube_carre'       // Section carrée pour toute la structure
}

// Paramètres de la structure de base
export interface ParametresStructureBase {
  type: TypeForme;
  largeur: number;
  longueur?: number; // Optionnel pour cercle et carré
  hauteur: number;
  nombreCotes?: number; // Pour polygones uniquement
  materiau: TypeMateriauGlobal; // Matériau pour toute la tonnelle
  epaisseur: number; // Épaisseur globale cohérente
  couleur: string; // Couleur globale de toute la tonnelle
}



// Point 3D pour géométrie
export interface Point3D {
  x: number;
  y: number;
  z: number;
}

// Géométrie de forme
export interface GeometrieForme {
  type: TypeForme;
  points: Point3D[];
  largeur?: number;
  longueur?: number;
  hauteur: number;
  nombreCotes?: number;
  rayon?: number;
  perimetre?: number;
}

// Poutre (Tâche 1.3)
export interface Poutre {
  id: string;
  chemin: Point3D[];
  hauteur: number;
  epaisseur: number;
  type: 'poutre';
  geometrie?: THREE.BufferGeometry;
}

// Montant vertical (Tâche 1.4)
export interface Montant {
  id: string;
  position: Point3D;
  hauteur: number;
  section: {
    largeur: number;
    profondeur: number;
  };
  geometrie?: THREE.BufferGeometry;
}

// Structure complète de base
export interface StructureBase {
  forme: GeometrieForme;
  poutres: {
    poutreBasse: Poutre;
    poutreHaute: Poutre;
  };
  montants: Montant[];
  parametres: ParametresStructureBase;
  nombreMontants: number;
  geometry?: THREE.Group;
  error?: string;
}

// Configuration du module
export interface StructureBaseModuleConfig {
  typesFormes: TypeForme[];
  valeursParDefaut: ParametresStructureBase;
  couleurs: {
    poutres: string;
    montants: string;
    forme: string;
  };
}

// Réponse API
export interface StructureBaseAPIResponse {
  geometrie?: GeometrieForme;
  poutres?: any;
  montants?: Montant[];
  nombreMontants?: number;
  espacementOptimal?: string;
  structure?: StructureBase;
  error?: string;
  success: boolean;
  module: string;
}

// Événements du module
export interface StructureBaseEvents {
  onParametresChange: (parametres: ParametresStructureBase) => void;
  onFormeChange: (forme: GeometrieForme) => void;
  onMontantsChange: (montants: Montant[]) => void;
  onStructureChange: (structure: StructureBase) => void;
  onError: (error: string) => void;
}

// État du module
export interface StructureBaseState {
  parametres: ParametresStructureBase;
  structure?: StructureBase;
  loading: boolean;
  error?: string;
  initialized: boolean;
}